import { reactive } from 'vue';

export const userStore = reactive({
    idToken: null,
    setIdToken(token) {
        this.idToken = token;
    },

    accessToken: null,
    setAccessToken(token) {
        this.accessToken = token;
    },

    userInfo: null,
    setUserInfo(userInfo) {
        this.userInfo = userInfo;
    },

    refreshingToken: false,
    setRefreshingToken(status) {
        this.refreshingToken = status;
    },
    
    //Controls if app forces a redirect to My Profile page on login, applies only to users with Adjuster role
    textMessagingEnableReminder: false,
    setTextMessagingReminder(flag) {
        this.textMessagingEnableReminder = flag;
    }
})